import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { RootState } from '../../utils/redux_store/store';
import { CandibankExplorerContent } from './CandibankExplorerContent';

export const CandibankExplorer = () => {
  const history = useHistory();

  const { subscriptions } = useSelector(
    (state: RootState) => state.subscriptions,
  );

  const isCandidate = localStorage.getItem('role') === 'Candidate';

  useEffect(() => {
    if (subscriptions && (!subscriptions.hierTalentCandiBank || isCandidate)) {
      history.push('/home');
    }
  }, [subscriptions]);

  if (!subscriptions || !subscriptions.hierTalentCandiBank || isCandidate) {
    return null;
  }

  return <CandibankExplorerContent />;
};
